"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.options = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _main = _interopRequireDefault(require("./main.scss"));

var _limitedWidth = _interopRequireDefault(require("../../hoc/limitedWidth"));

var _Boxed = _interopRequireDefault(require("../../hoc/Boxed"));

var _reactCssThemr = require("react-css-themr");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var options = {};
exports.options = options;

var factory = function factory(_ref) {
  var identifier = _ref.identifier;

  var List = /*#__PURE__*/function (_React$Component) {
    _inherits(List, _React$Component);

    var _super = _createSuper(List);

    function List() {
      _classCallCheck(this, List);

      return _super.apply(this, arguments);
    }

    _createClass(List, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            borderRadius = _this$props.borderRadius,
            align = _this$props.align,
            preventDesktopBehaviour = _this$props.preventDesktopBehaviour,
            theme = _this$props.theme;

        var childrenWithProps = _react["default"].Children.map(children, function (child) {
          return /*#__PURE__*/_react["default"].cloneElement(child, {
            align: align,
            borderRadius: borderRadius
          });
        });

        var containerClasses = (0, _classnames["default"])(theme.container, _defineProperty({}, theme.preventDesktopBehaviour, preventDesktopBehaviour));
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: containerClasses
        }, childrenWithProps);
      }
    }]);

    return List;
  }(_react["default"].Component);

  List.displayName = identifier;
  List.propTypes = {
    children: _propTypes["default"].arrayOf(_propTypes["default"].node).isRequired,
    align: _propTypes["default"].oneOf(['left', 'center']),
    borderRadius: _propTypes["default"].oneOf(['minor', 'major']),
    preventDesktopBehaviour: _propTypes["default"].bool.isRequired
  };
  List.defaultProps = {
    align: 'left',
    borderRadius: 'minor',
    isResponsive: true,
    preventDesktopBehaviour: false,
    box: {
      top: 'large',
      bottom: 'large',
      left: 'large',
      right: 'large'
    }
  };
  var themed = (0, _reactCssThemr.themr)(identifier, _main["default"])(List);
  var limited = (0, _limitedWidth["default"])(themed, 'list');
  return (0, _Boxed["default"])(true)(limited);
};

var _default = factory;
exports["default"] = _default;